var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main_home"},[_c('div',{staticClass:"about_main"},[(_vm.data.image)?_c('div',{staticClass:"about_img"},[_c('img',{attrs:{"src":_vm.data.image}})]):_vm._e(),_c('div',{staticClass:"about_box"},[_c('div',{staticClass:"ui violet segment about_text",domProps:{"innerHTML":_vm._s(_vm.parseHtml(_vm.data.text))}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }